import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {IeDsFolder, IeDsResource, IRenameResource, iseDsFile, isValidResourceName} from "../../../../models/user-info";
import {Observable} from "rxjs";


@Component({
  selector: 'app-rename-resource-dialog',
  templateUrl: './rename-resource-dialog.component.html',
  styleUrls: ['./rename-resource-dialog.component.scss']
})
export class RenameResourceDialogComponent implements OnInit {
  currentFolder$: Observable<IeDsFolder[]>;
  resource: IeDsResource;
  path: string;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<RenameResourceDialogComponent>) {
    this.resource = data.file;
    this.currentFolder$ = data.currentFolder;
  }

  ngOnInit() {
    this.currentFolder$.subscribe(x => this.path = '/' + x.map(y => y.label).join('/'));
  }

  closeDlg(res: IRenameResource) {
    this.dialogRef.close(res);
  }

  save(name: string) {

    if (isValidResourceName(name)) {
      const res: IRenameResource = {
        id: this.resource.id,
        path: this.path,
        oldName: this.resource.label,
        newName: name,
        isFile: iseDsFile(this.resource)
      };

      this.closeDlg(res);
    } else {
      this.closeDlg(null);
    }

  }
  acceptOnlyCharNumber(evt) {
    return  (/[a-z_\-\.\d]/i.test(evt.key));
  }
}
